export default __webpack_public_path__ + "static/media/img_2.f42f0109.png";